import {
  Box,
  HStack,
  Heading,
  Icon,
  Text,
  Button,
  InputGroup,
  InputLeftElement,
  Input,
} from "@chakra-ui/react";
import { IoIosAddCircleOutline } from "react-icons/io";
import { FiUpload, FiSearch } from "react-icons/fi";
import { Table } from "../../components/Table/Table";
import { useApplications } from "./useApplications";
import { AddApplicationModal } from "../../components/AddApplicationModal/AddAplicationModal";
import { ImportApplicationModal } from "../../components/ImportApplicationModal/ImportApplicationModal";

export const Applications = () => {
  const {
    configureAnalytics,
    columns,
    columnData,
    isAddApplicationModalOpen,
    onAddApplicationModalClose,
    isApplicationEditModelOpen,
    onApplicationEditModeClose,
    edit,
    selectedApplication,
    isImportApplicationModalOpen,
    onImportApplicationModalOpen,
    onImportApplicationModalClose,
    onApplicationImportClick,
    loading,
    searchTerm,
    setSearchTerm,
    filteredApplications,
  } = useApplications();

  return (
    <Box>
      {/* <Box
        backgroundColor="rgba(255, 255, 255, 0.05)"
        backdropFilter="blur(20px)"
        borderWidth="1px"
        borderColor="rgba(255, 255, 255, 0.1)"
        borderRadius="20px"
        my={4}
        p={6}
      >
        <HStack>
          <Heading fontSize="18px" fontWeight="600">
            Configure Applications
          </Heading>
        </HStack>
        <Box>
          <HStack wrap="wrap" mt={4}>
            {configureAnalytics
              .filter((element) => element.enabled)
              .map((element, index) => (
                <HStack
                  minWidth={`${90 / 3}%`}
                  onClick={element.onClick}
                  justifyContent="space-between"
                  cursor="pointer"
                  borderRadius="md"
                  borderWidth="1px"
                  key={index}
                  mr={index + 1 === configureAnalytics.length ? 0 : 2}
                  p={6}
                >
                  <HStack>
                    <Icon
                      as={element.icon as React.ElementType}
                      boxSize="24px"
                      color="brand.700"
                    />
                    <Text noOfLines={1}>{element.title}</Text>
                  </HStack>
                  <Icon
                    as={IoIosAddCircleOutline as React.ElementType}
                    boxSize="24px"
                    color="brand.600"
                  />
                </HStack>
              ))}
          </HStack>
        </Box>
      </Box> */}
      <Box
        backgroundColor="rgba(255, 255, 255, 0.05)"
        backdropFilter="blur(20px)"
        borderRadius="20px"
        borderWidth="1px"
        borderColor="rgba(255, 255, 255, 0.1)"
        my={4}
        overflow="visible"
        // p={6}
      >
        <Box p={6}>
          <HStack justifyContent="space-between" mb={4}>
            <HStack>
              <Heading fontSize="18px" fontWeight="600">
                Your Applications
              </Heading>
              {/* <Text fontSize="sm" color="gray.500">
                ({filteredApplications.length} of {applications.length}{" "}
                applications)
              </Text> */}
            </HStack>
            <HStack spacing={3}>
              <InputGroup>
                <InputLeftElement
                  pointerEvents="none"
                  children={
                    <Icon as={FiSearch as React.ElementType} color="gray.400" />
                  }
                />
                <Input
                  placeholder="Search by applications name"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </InputGroup>

              <Button
                leftIcon={
                  <Icon as={FiUpload as React.ElementType} boxSize="16px" />
                }
                onClick={onImportApplicationModalOpen}
                colorScheme="brand"
                variant="outline"
                size="md"
                height="40px"
                isLoading={loading}
                borderRadius="12px"
                style={{ paddingLeft: "24px", paddingRight: "24px" }}
              >
                Import
              </Button>
              <Button
                onClick={configureAnalytics[0].onClick}
                background="linear-gradient(to right, #7652f7, #9500ff)"
                variant="solid"
                size="md"
                height="40px"
                _hover={{
                  background: "linear-gradient(to right, #7652f7, #9500ff)",
                  transform: "translateY(-1px)",
                  boxShadow: "0 6px 20px rgba(118, 82, 247, 0.4)",
                }}
                isLoading={loading}
                borderRadius="12px"
                style={{ paddingLeft: "24px", paddingRight: "24px" }}
              >
                Add New
              </Button>
            </HStack>
          </HStack>
        </Box>
        <Table columns={columns} data={columnData} />
      </Box>
      <AddApplicationModal
        isOpen={isAddApplicationModalOpen}
        onClose={onAddApplicationModalClose}
        onImport={onApplicationImportClick}
      />
      <AddApplicationModal
        isOpen={isApplicationEditModelOpen}
        onClose={onApplicationEditModeClose}
        edit={edit}
        application={selectedApplication}
        onImport={onApplicationImportClick}
      />
      <ImportApplicationModal
        isOpen={isImportApplicationModalOpen}
        onClose={onImportApplicationModalClose}
        onImport={onApplicationImportClick}
        loading={loading}
      />
    </Box>
  );
};
